import {IApiActionResult} from "src/~api/ApiActionResult";
import {IOperator} from "../~store/models/Operator";
import {fetchGet, fetchPost, getApiActionResult, fetchGetFile} from "src/~api/ApiHelper";
import {
    GET_OPERATORS_API_ROUTE,
    SAVE_OPERATOR_API_ROUTE,
    DELETE_OPERATOR_API_ROUTE,
    CHANGE_OPERATOR_AVATAR_API_ROUTE,
    GET_SETTING_BY_OPERATOR_ID_API_ROUTE,
    SAVE_OPERATOR_SETTING_API_ROUTE,
    DELETE_OPERATOR_SETTING_API_ROUTE,
    GET_OPERATOR_BY_ID_API_ROUTE,
    GET_SETTINGS_BY_OPERATORS_ID_API_ROUTE,
    DOWNLOAD_BOT_SCRIPT_API_ROUTE
} from './apiRoutes';
import { OperatorRole } from "../~store/models/enums/OperatorRole";
import { ISetting } from "src/app/setting/~store/models/setting";
import { IBot } from "../~store/models/Bot";

export const getAllOperatorsAsync = async (includeBots: boolean = true, includeDeleted: boolean = false): Promise<IApiActionResult<IOperator[]>> => {
    const fetchPromise = fetchGet(GET_OPERATORS_API_ROUTE + `?includeBots=${includeBots}&includeDeleted=${includeDeleted}`);
    return await getApiActionResult(fetchPromise, true);
};

export const getOperatorByIdAsync = async (operatorId: number): Promise<IApiActionResult<IOperator>> => {
    const fetchPromise = fetchGet(GET_OPERATOR_BY_ID_API_ROUTE + "?operatorId=" + operatorId);

    return await getApiActionResult(fetchPromise, true);
}

export const saveOperatorAsync = async (newOperator: IOperator, updatedById?: number, scriptFile?: File): Promise<IApiActionResult<IOperator>> => {
    const formData = new FormData();
    console.log(scriptFile);
    formData.append("scriptFile", scriptFile ?? "");
    formData.append("updatedById", updatedById ? updatedById.toString() : "0");
    formData.append("data", JSON.stringify(newOperator));
    const fetchPromise = fetchPost(SAVE_OPERATOR_API_ROUTE ,{
        body: formData
    });
    return await getApiActionResult(fetchPromise, true);;
}

export const deleteOperatorAsync = async (operator: IOperator): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(DELETE_OPERATOR_API_ROUTE, {
        body: JSON.stringify(
            {
                operatorId: operator.operatorId,
                type: operator.type
            }
        ),
    });

    return await getApiActionResult(fetchPromise);;
}

export const downloadBotScriptAsync = async (operator: IOperator, fileName: string): Promise<IApiActionResult<Blob>> => {
    const fetchPromise = fetchGetFile(`${DOWNLOAD_BOT_SCRIPT_API_ROUTE}?operatorId=${operator.operatorId}`, fileName);
    return await getApiActionResult(fetchPromise, false);
}

export const changeOperatorAvatarAsync = async (operatorId: number, avatarId: string): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(CHANGE_OPERATOR_AVATAR_API_ROUTE, {
        body: JSON.stringify({
            operatorId,
            avatarId
        })
    })
    return await getApiActionResult(fetchPromise, false);
}

export const getSettingByOperatorIdAsync = async (operatorId: number): Promise<IApiActionResult<ISetting>> => {
    const fetchPromise = fetchGet(GET_SETTING_BY_OPERATOR_ID_API_ROUTE + operatorId);
    return await getApiActionResult(fetchPromise, true);
}

export const getSettingsByOperatorsIdAsync = async (operatorsId: number[]): Promise<IApiActionResult<ISetting[]>> => {
    const fetchPromise = fetchPost(GET_SETTINGS_BY_OPERATORS_ID_API_ROUTE, {
        body: JSON.stringify({operatorsId})
        });
    return await getApiActionResult(fetchPromise, true);
}

export const saveOperatorSettingAsync = async (
    operatorId: number, 
    setting: string
): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(SAVE_OPERATOR_SETTING_API_ROUTE, {
        body: JSON.stringify({
            operatorId,
            data: {
                value: setting,
            }
        })
    })
    return await getApiActionResult(fetchPromise, false);
}

export const deleteOperatorSettingAsync = async (operatorId: number): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(DELETE_OPERATOR_SETTING_API_ROUTE + operatorId, {});
    return await getApiActionResult(fetchPromise, false);
}
